import { Modal } from "@mantine/core";
import { SystemEmailModeConfirmContent } from "./SystemEmailModeConfirmContent";
import { SystemEmailModeConfirmModel } from "./systemEmailModeConfirmModel";

export function SystemEmailModeConfirmModal({
  model,
}: {
  model: SystemEmailModeConfirmModel;
}) {
  return (
    <Modal
      centered
      closeOnClickOutside={false}
      onClose={model.onClose}
      opened={model.opened}
      title="Change send mode?"
    >
      <SystemEmailModeConfirmContent model={model} />
    </Modal>
  );
}
